// assets
import { BookOutlined } from '@ant-design/icons';

// icons
const icons = {
  BookOutlined
};

// ==============================|| MENU ITEMS - LEARNING ||============================== //

const dashboard = {
  id: 'group-learning',
  title: 'Learning',
  type: 'group',
  children: [
    {
      id: 'my-courses',
      title: 'My Courses',
      type: 'item',
      url: '/dashboard',
      icon: icons.BookOutlined,
      breadcrumbs: false
    }
  ]
};

export default dashboard;
